import React from 'react';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaGlobe } from 'react-icons/fa';
import IframeModal from '../components/IframeModal';

const urlParams = new URLSearchParams(window.location.search);
let initialSidebarHidden;
if (urlParams.has('show_sidebar')) {
  initialSidebarHidden = urlParams.get('show_sidebar') === 'false';
} else if (localStorage.getItem('sidebar_hidden') !== null) {
  initialSidebarHidden = localStorage.getItem('sidebar_hidden') === 'true';
} else {
  initialSidebarHidden = false;
}

console.log('initialSidebarHidden', initialSidebarHidden);

const SidebarToggle = () => {
  const [isSidebarHidden, setIsSidebarHidden] = React.useState(initialSidebarHidden);
  const [modalOpen, setModalOpen] = React.useState(false);

  // Sync class with state on mount and when isSidebarHidden changes
  React.useEffect(() => {
    const root = document.getElementById('root');
    if (isSidebarHidden) {
      root.classList.add('no-sidebar');
    } else {
      root.classList.remove('no-sidebar');
    }
  }, [isSidebarHidden]);

  const handleToggle = () => {
    const root = document.getElementById('root');
    root.classList.toggle('no-sidebar');
    const hidden = root.classList.contains('no-sidebar');
    setIsSidebarHidden(hidden);
    localStorage.setItem('sidebar_hidden', hidden);
    // Remove show_sidebar param from URL if present
    const url = new URL(window.location.href);
    if (url.searchParams.has('show_sidebar')) {
      url.searchParams.delete('show_sidebar');
      window.history.replaceState({}, '', url);
    }
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div
          id="sidebar-toggle-btn"
          className="sidebar-toggle"
          onClick={handleToggle}
        >
          {isSidebarHidden ? <FaAngleDoubleRight /> : <FaAngleDoubleLeft />}
        </div>
        <div
          id="sidebar-internet-btn"
          className="sidebar-internet-icon"
          style={{ marginTop: 12, cursor: 'pointer' }}
          onClick={handleOpenModal}
        >
          <FaGlobe />
        </div>
      </div>
      <IframeModal
        show={modalOpen}
        showSidebar={true}
        onHide={handleCloseModal}
        url={window.location.origin}
        title="Trang chủ (iframe)"
      />
    </>
  );
};

export default SidebarToggle; 